import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'



firebase.initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
})

export const database = firebase.firestore()
export const app = database.doc('qa/app')
export const batch = database.doc('qa/batch')
export const users = database.doc('qa/users')
export const batches = database.collection('qa/batch/batches')
